window.roundupInitializer = function () {
  var roundUpVariantId = window.ROUNDUP_VARIANT_ID;
  document.querySelector(".round_up_container").style.display = "flex";
  window.roundupChecking = false;
  var  roundupProdInput = document.querySelector("input[id*='" + roundUpVariantId + "']");

  if (roundupProdInput) {
    document.querySelector(".roundup_donation_amount").value=roundupProdInput.value;
  }
  function afterFinish(target) {
    var $target = jQuery(target);
    if ($target.attr("href")) {
      window.location.href = $target.attr("href");
      return;
    }

    $target.trigger("click");
  }

  function handleRoundUp(ev) {
    var roundUpVariantId = window.ROUNDUP_VARIANT_ID;
    if (window.roundupChecking) return true;
    console.log("checkout clicked...");
    ev.preventDefault();
    ev.stopPropagation();
    window.roundupChecking = true;
    var addRoundUp = document.querySelector(".round_up_checkbox").checked
    var quantity = parseInt(document.querySelector(".roundup_donation_amount").value);

    console.log("addRoundUp: " + addRoundUp);
    console.log("donation amount: " + quantity);
    jQuery.getJSON("/cart.js", function (cart) {
      var roundProdExist = false;

      var cartQuantity = 0;
      jQuery.each(cart.items, function (index, value) {
        if (value.id == roundUpVariantId) {
          cartQuantity = value.quantity;
          roundProdExist = true;
        }
      });

      if (addRoundUp && !roundProdExist) {
        var params = {
          type: "POST",
          url: "/cart/add.js",
          async: false,
          data: "quantity=" + quantity + "&id=" + roundUpVariantId,
          dataType: "json",
          success: function () {
            console.log("add success...");
            afterFinish(ev.target);
          },
        };
        jQuery.ajax(params);
        console.log("add roundup prod");
      } else if (
        (!addRoundUp && roundProdExist) ||
        (addRoundUp && cartQuantity != quantity)
      ) {
        if (!addRoundUp) {
          quantity = 0;
        }
        
        jQuery("input[id*='" + roundUpVariantId + "']").val(quantity);
        afterFinish(ev.target);
        console.log("update/remove roundup prod");
      } else {
        afterFinish(ev.target);
      }
    });

    return false;
  }

 document.addEventListener('click',function(e){
  if(e.target && e.target.name== 'checkout'){
      handleRoundUp(e);
   }
 });
};